import { render, staticRenderFns } from "./YearReportsTab.vue?vue&type=template&id=67765700"
import script from "./YearReportsTab.vue?vue&type=script&lang=js"
export * from "./YearReportsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports